// FOLLOWER BOOST V8.1 — un seul bouton vert par parcours d'achat, un seul système de paiement (SumUp).
//
// Fiche prestation : « Commander maintenant » garde ses validations (celles de fb-configurator.js),
// puis, au lieu d'ajouter au panier, soumet le formulaire du bloc d'app « SumUp — Bouton produit »
// (masqué) : l'app recopie variante + propriétés (cible, service, pack) et ouvre « Finaliser votre commande ».
// Panier et tiroir panier : « Payer » soumet le bloc « SumUp — Panier » (relu depuis /cart.js au moment
// du paiement) ; hors page panier, le même envoi est construit ici. Le checkout Shopify classique n'est
// jamais ouvert par ces boutons.
// L'e-mail n'est plus demandé sur la boutique : la page « Finaliser votre commande » le collecte
// (prérempli si le client est connecté). Prix, devise et taxes restent calculés par Shopify côté app.

const cfgEl = document.getElementById('fb-sumup-bridge');
let cfg = null;
try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : null; } catch { cfg = null; }

const BUSY_MS = 8000;
let paying = false;
let busyTimer = 0;

function setBusy(btn, on) {
  if (!btn) return;
  if (on) {
    btn.setAttribute('data-fb-sumup-busy', '');
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
  } else {
    btn.removeAttribute('data-fb-sumup-busy');
    btn.removeAttribute('aria-busy');
    btn.classList.remove('is-loading');
  }
}

/** Un seul envoi à la fois (double clic, double tap) ; libéré au retour arrière ou après un délai. */
function lock(btn) {
  if (paying) return false;
  paying = true;
  setBusy(btn, true);
  clearTimeout(busyTimer);
  busyTimer = setTimeout(() => release(btn), BUSY_MS);
  return true;
}
function release(btn) {
  paying = false;
  clearTimeout(busyTimer);
  setBusy(btn, false);
  document.querySelectorAll('[data-fb-sumup-busy]').forEach((b) => setBusy(b, false));
}
window.addEventListener('pageshow', () => release(null));

/** Le bloc SumUp est masqué : son e-mail devient facultatif (collecté sur la page de commande). */
function prepare(form) {
  form.noValidate = true;
  const email = form.querySelector('input[type="email"]');
  if (email) {
    email.required = false;
    if (!email.value && cfg?.email) email.value = cfg.email;
  }
  // Client connecté : prénom/nom préremplis sur « Finaliser votre commande » (modifiables).
  for (const name of ['firstName', 'lastName']) {
    if (!cfg?.[name] || form.querySelector(`input[name="${name}"]`)) continue;
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = name; input.value = cfg[name];
    form.appendChild(input);
  }
}

/* ---------- Fiche prestation ---------- */

/** Formulaire SumUp (bloc d'app masqué) de la même section que le formulaire du thème. */
function sumupFormFor(themeForm) {
  const section = themeForm.closest('.shopify-section') || document;
  return section.querySelector('form[data-sumup-form="product"]');
}

// Horizon traite « submit » et « click » par délégation sur le document en phase capture : on écoute
// sur window (capture), donc avant lui. Les validations restent celles du configurateur (fb-configurator.js).
window.addEventListener(
  'submit',
  (e) => {
    const themeForm = e.target;
    if (!(themeForm instanceof HTMLFormElement) || themeForm.dataset.type !== 'add-to-cart-form') return;
    const fb = themeForm.closest('[data-fb-config]')?.__fb;
    // V8.2 : « Ajouter au panier » laisse Horizon ajouter la ligne au panier Shopify (sans paiement).
    if (fb && e.submitter?.matches?.('[data-fb-add-cart]')) {
      addToCart(e, fb, themeForm, e.submitter);
      return;
    }
    const sumupForm = sumupFormFor(themeForm);
    if (!fb || !sumupForm) return; // bloc absent : comportement natif conservé
    e.stopImmediatePropagation(); // ni ajout au panier Horizon, ni double traitement
    fb.onSubmit(e); // cible vide / invalide / non confirmée : le thème affiche l'erreur
    if (e.defaultPrevented) return;
    e.preventDefault();
    const btn = themeForm.querySelector('[data-fb-submit]');
    if (!lock(btn)) return;
    prepare(sumupForm);
    const once = (ev) => {
      sumupForm.removeEventListener('submit', once);
      if (ev.defaultPrevented) release(btn); // refusé par le bloc : rien n'est envoyé
    };
    sumupForm.addEventListener('submit', once);
    sumupForm.requestSubmit();
  },
  true
);

// Bouton prêt : pas d'animation « ajouté au panier » (rien n'est ajouté au panier) ; le clic
// déclenche simplement l'envoi du formulaire ci-dessus. Bouton non prêt : le configurateur gère.
window.addEventListener(
  'click',
  (e) => {
    const btn = e.target?.closest?.('[data-fb-config] [data-fb-submit]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    const themeForm = btn.form;
    if (!themeForm || !sumupFormFor(themeForm)) return;
    e.stopImmediatePropagation();
    if (paying) e.preventDefault(); // double clic : un seul envoi
  },
  true
);

/* ---------- V8.2 : Ajouter au panier (action secondaire de la fiche) ---------- */

const ADD_LOCK_MS = 1500;
let addingUntil = 0;

/** Cible vide / invalide / non confirmée : rien n'est ajouté, le configurateur montre l'étape manquante. */
function targetReady(fb) {
  if (!fb.validate(true)) { fb.target?.focus(); return false; }
  if (!fb.confirmed) { fb.maybeAskConfirm(true); return false; }
  return true;
}

function addToCart(e, fb, themeForm, btn) {
  if (Date.now() < addingUntil || !targetReady(fb)) {
    e.preventDefault();
    e.stopImmediatePropagation(); // ni Horizon, ni doublon (double clic)
    return;
  }
  // Valeurs normalisées dans le formulaire AVANT qu'Horizon lise le FormData (il écoute en capture sur document).
  fb.target.value = fb.normalized || fb.target.value.trim();
  if (fb.targetHidden) fb.targetHidden.value = fb.target.value;
  addingUntil = Date.now() + ADD_LOCK_MS;
  btn.classList.add('is-loading');
  btn.setAttribute('aria-busy', 'true');
  // Le configurateur marque « Commander maintenant » comme en cours : pas pour un simple ajout.
  const main = themeForm.querySelector('[data-fb-submit]');
  setTimeout(() => main?.classList.remove('is-loading'), 0);
  const label = btn.querySelector('[data-fb-add-cart-label]');
  const done = () => {
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
    if (label && btn.dataset.labelAdded) {
      label.textContent = btn.dataset.labelAdded;
      setTimeout(() => { label.textContent = btn.dataset.label || label.textContent; }, 2000);
    }
  };
  document.addEventListener('cart:update', done, { once: true });
  setTimeout(() => { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }, ADD_LOCK_MS);
  // L'événement continue vers Horizon : ajout au panier, compteur, ouverture du tiroir.
}

// Clic sur « Ajouter au panier » alors que la cible n'est pas prête : on guide sans envoyer.
window.addEventListener(
  'click',
  (e) => {
    const btn = e.target?.closest?.('[data-fb-config] [data-fb-add-cart]');
    if (!btn || btn.disabled) return;
    const fb = btn.closest('[data-fb-config]')?.__fb;
    if (!fb) return;
    if (Date.now() < addingUntil || !targetReady(fb)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  },
  true
);

/* ---------- Panier (page et tiroir) ---------- */

function cartRoot() {
  const r = window.Shopify?.routes?.root || cfg?.root || '/';
  return r.endsWith('/') ? r : `${r}/`;
}

async function payCart(btn) {
  if (!lock(btn)) return;
  const block = document.querySelector('form[data-sumup-form="cart"]');
  if (block) {
    // Bloc présent (page panier) : il relit /cart.js puis envoie le panier tel qu'il est maintenant.
    prepare(block);
    block.requestSubmit();
    return;
  }
  if (!cfg?.cartAction) { release(btn); return; }
  try {
    const cart = await fetch(`${cartRoot()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json());
    const items = (cart.items || []).map((i) => {
      const line = { variant_id: i.variant_id, quantity: i.quantity };
      if (i.properties && typeof i.properties === 'object') line.properties = i.properties;
      return line;
    });
    if (!items.length) { release(btn); return; }
    const form = document.createElement('form');
    form.method = 'post';
    form.action = cfg.cartAction;
    form.hidden = true;
    const add = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value;
      form.appendChild(input);
    };
    add('cart', JSON.stringify({ items }));
    add('locale', cfg.locale || 'fr');
    add('root', cfg.root || '/');
    if (cfg.email) add('email', cfg.email);
    if (cfg.firstName) add('firstName', cfg.firstName);
    if (cfg.lastName) add('lastName', cfg.lastName);
    document.body.appendChild(form);
    form.submit();
  } catch {
    release(btn);
  }
}

const isCheckoutButton = (el) => el?.closest?.('button[name="checkout"], input[name="checkout"]');

// Capture sur window : avant tout gestionnaire du thème (Horizon délègue sur le document),
// pour le clic comme pour la touche Entrée.
window.addEventListener(
  'click',
  (e) => {
    const btn = isCheckoutButton(e.target);
    if (!btn || !cfg) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.disabled) return;
    payCart(btn);
  },
  true
);
window.addEventListener(
  'submit',
  (e) => {
    if (!cfg) return;
    const submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') {
      e.preventDefault();
      e.stopImmediatePropagation();
      payCart(submitter);
    }
  },
  true
);
